<script setup lang="ts">
import type { BookAndArticle } from '~/utils/solr/literature'

const { book } = defineProps<{
  book: BookAndArticle | null
  type: 'law-commentary' | 'book'
}>()

const offset = useHeaderHeight()
</script>

<template>
  <ContentDiv v-if="book">
    <div class="flex flex-col min-[790px]:flex-row gap-m lg:gap-l xl:gap-2xl max-w-screen-xl mx-auto py-xl">
      <div class="relative mx-auto min-[790px]:mx-0">
        <LiteratureCard
          data-sticky-book-card
          :title="book?.title ?? ''"
          :image="book?.coverImage ?? ''"
          class="sticky"
          size="large"
          presentation
        />
      </div>
      <div class="flex-1 flex flex-col gap-xl pb-2xl">
        <LiteratureDescriptionHeader :book="book" :type="type" />

        <LiteratureKolofon :book="book" />

        <BodyText v-if="book.description" :html="book.description" source="biblio" />

        <LiteratureRelationList v-if="type === 'book'" :book="book" />
      </div>
    </div>
  </ContentDiv>
</template>

<style scoped lang="postcss">
[data-sticky-book-card] {
  top: calc(v-bind(offset) + theme('spacing.s'));
}
</style>
